import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const handleUpdate = listeners["handleUpdate"] || function () { };
  const handleDelete = listeners["handleDelete"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    const dealConf = [];
    if (curItem.isUpdate == 2) {
      dealConf.push([
        "iconfont ic_updated iconfont-adapt-disabled",
        "已更新",
        () => { },
        "user:retire:batch"
      ]);
    } else {
      dealConf.push([
        "iconfont ic_toupdate iconfont-adapt",
        "更新",
        () => handleUpdate(curItem),
        "user:retire:batch"
      ]);
    };
    dealConf.push(["icon-remove", "移除", () => handleDelete(curItem),""]);

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const MatchRemark = ({ props: { vo } }) => {
    return <span>{vo.row.matchRemark || "--"}</span>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "所在行",
      prop: "placeRowName",
      width: "80",
    },
    {
      label: "唯一标识",
      prop: "unique",
      width: "120"
    },
    {
      label: "手机号码",
      prop: "userMobile",
      width: "120"
    },
    {
      label: "所属分院",
      prop: "oldAcademyName",
      width: "150",
    },
    {
      label: "工作单位",
      prop: "oldDeptName",
      width: "150",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "oldPosition",
      width: "150",
      showOverflowTooltip: true
    },
    {
      label: "备注",
      prop: "matchRemark",
      width: "150",
      render: (vo) => <MatchRemark vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "操作",
      width: "110",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
